import { render, staticRenderFns } from "./bFileInputValidation.vue?vue&type=template&id=4c747b32&scoped=true"
import script from "./bFileInputValidation.ts?vue&type=script&lang=ts&external"
export * from "./bFileInputValidation.ts?vue&type=script&lang=ts&external"
import style0 from "./bFileInputValidation.vue?vue&type=style&index=0&id=4c747b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c747b32",
  null
  
)

export default component.exports